import { quickQuoteUrl } from "@/lib/site-data";
import jakeWAsset from "@/assets/jake-w.png.asset.json";

export function HeroNoShave() {
  return (
    <section data-cta-location="hero" className="bg-background">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 pt-4 md:pt-6 lg:grid-cols-2 lg:px-8 lg:pt-8">
        <div className="pb-8 md:pb-10 lg:pb-12">
          <h1 className="text-sm font-bold tracking-wide text-foreground">
            RESTORE® No Shave™ Hair Transplant
          </h1>
          <div className="mt-5">
            <h2 className="text-3xl font-medium leading-tight text-foreground md:text-[45px]">
              You Can Now Get Your Hair Restored <em className="font-medium">Without</em>...
            </h2>
            <h2 className="mt-3 text-3xl font-extrabold leading-tight text-foreground md:text-[45px]">
              Shaving Your Head
            </h2>
          </div>
          <p className="mt-6 text-base leading-relaxed text-muted-foreground">
            RESTORE® is one of the only clinics offering a No-Shave Hair Transplant procedure. Our
            highly coveted RESTORE® No-Shave FUE™ Hair Restoration procedure is the most discreet
            and undetectable way to get your hair back.
          </p>
          <a
            href={quickQuoteUrl}
            className="mt-8 inline-block bg-primary px-8 py-4 text-sm font-bold tracking-wider text-primary-foreground transition hover:bg-primary/90"
          >
            Get a Quick Quote
          </a>
        </div>
        <div className="relative self-end">
          <div className="px-2 pb-3 md:hidden">
            <span className="inline-block bg-[#F7E6BF] px-2 py-1 text-xs font-medium text-foreground">
              Jake W
            </span>
            <div className="mt-1 text-xs italic text-muted-foreground">RESTORE Client</div>
          </div>
          <div className="absolute left-4 -top-2 z-10 hidden px-4 py-2 text-xs font-medium text-foreground md:block md:text-sm">
            <span className="inline-block bg-[#F7E6BF] px-2 py-1 text-xs font-medium text-foreground md:text-sm">
              Jake W
            </span>
            <div className="mt-1 text-xs italic text-muted-foreground">RESTORE Client</div>
          </div>
          <img loading="lazy" decoding="async"
            src={jakeWAsset.url}
            alt="Jake W, RESTORE Client, holding a before photo of his hair loss"
            width={768}
            height={744}
            className="block w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
}
